import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiFilter, ApiSort } from "@result/rui/utils/api";

import ApiClient from "#/redux/api/ApiClient";

const baseUrl = "/api/dog/testna_postaja/cenik";

export const ERROR_NO_PRICE_CURRENTLY_VALID = "NO_PRICE_CURRENTLY_VALID";

/**
 *
 * @returns price by id or currently valid price if id is not provided
 */
export const getTestStationPrice = createAsyncThunk(
  "testStationPriceList/getAll",
  async ({ id }, { rejectWithValue }) => {
    try {
      if (id != null) {
        const response = await ApiClient.get(`${baseUrl}/${id}`, null);
        return response.data;
      }
      const today = new Date().toISOString().slice(0, 10);
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        null,
        { page: 0, size: 10 },
        new ApiFilter().and((orGroup) => {
          orGroup.where("validFrom", "LTE", today);
          orGroup.where("validTo", "GTE", today);
        }),
        new ApiSort().sort("version", "DESC").toQueryString()
      );
      if (response.data.content.length === 0) {
        return rejectWithValue(ERROR_NO_PRICE_CURRENTLY_VALID);
      }
      return response.data.content[0];
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  current: {},
  list: [],
  isLoading: false,
  error: null,
};

const testStationPriceListSlice = createSlice({
  name: "testStationPriceList",
  initialState: initialState,
  reducers: {
    resetPriceListState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTestStationPrice.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getTestStationPrice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.current = action.payload;
      })
      .addCase(getTestStationPrice.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default testStationPriceListSlice.reducer;

export const { resetPriceListState } = testStationPriceListSlice.actions;
